export default __webpack_public_path__ + "static/media/OGNinja.9fd9bb6a.webp";